__turbopack_context__.v({
  "text": "ToBeAnnouncedLocation-module-scss-module__Iu8AhW__text",
  "toBeAnnouncedLocation": "ToBeAnnouncedLocation-module-scss-module__Iu8AhW__toBeAnnouncedLocation",
});
